import { formatSupabaseError } from './formatSupabaseError';
import { getDbSupabase } from './supabase';
import type { DemWarehouseAddress } from '../types/dem';

const WAREHOUSE_KEY = 'delivery_warehouse_addresses';

function parseWarehouseList(raw: string | undefined): DemWarehouseAddress[] {
  if (!raw?.trim()) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    const rows: DemWarehouseAddress[] = [];
    parsed.forEach((item, index) => {
      if (!item || typeof item !== 'object') return;
      const row = item as Record<string, unknown>;
      const label = String(row.label ?? '').trim();
      const address = String(row.address ?? '').trim();
      if (!label || !address) return;
      rows.push({
        id: String(row.id ?? `wh-${index}`),
        label,
        name: String(row.name ?? '').trim(),
        phone: String(row.phone ?? '').trim(),
        address,
        unitNo: String(row.unitNo ?? '').trim() || undefined,
        building: String(row.building ?? '').trim() || undefined,
        postal: String(row.postal ?? '').trim(),
      });
    });
    return rows;
  } catch {
    return [];
  }
}

export async function fetchDeliveryWarehouseAddresses(): Promise<DemWarehouseAddress[]> {
  const db = getDbSupabase('dem');
  const { data, error } = await db
    .from('dispatch_settings')
    .select('value')
    .eq('key', WAREHOUSE_KEY)
    .maybeSingle();

  if (error) throw new Error(formatSupabaseError(error));
  return parseWarehouseList((data as { value?: string } | null)?.value);
}

export async function saveDeliveryWarehouseAddresses(
  addresses: DemWarehouseAddress[],
): Promise<void> {
  const db = getDbSupabase('dem');
  const { error } = await db.from('dispatch_settings').upsert({
    key: WAREHOUSE_KEY,
    value: JSON.stringify(addresses),
  });
  if (error) throw new Error(formatSupabaseError(error));
}
